<h2 class="heading-underline"><mat-icon fontIcon="{{icon}}"></mat-icon> {{title}}</h2>
<div class="clear-input">
  <input type="text" [placeholder]="searchInputFocused ? 'Search or add your own...' : placeholder" (keydown.enter)="addNewUserOption()"
    aria-label="Select or add an item" matInput [formControl]="optionControl"
    (focus)="searchInputFocused = true" (blur)="searchInputFocused = false"
    [matTooltip]="placeholder" matTooltipShowDelay="500" [matTooltipPosition]="'above'"
    [matAutocomplete]="auto" #input [tabindex]="preventTabFocusOnFirstLoad">
    <i class="return-icon" [ngClass]="{'green': addingOption, 'disabled': !input.value}"
      (click)="addNewUserOption()" (keydown.enter)="addNewUserOption()" (keydown.space)="addNewUserOption()"
    [tabindex]="input.value ? '0' : '-1'" matTooltip="Hit 'Enter' to add" matTooltipShowDelay="500"></i>
    <mat-icon fontIcon="close" class="clear-icon" [ngClass]="{'disabled' : !input.value}"
      (click)="clearInput(input, true)" (keydown.enter)="clearInput(input, true)" (keydown.space)="clearInput(input, true)"
    [tabindex]="input.value ? '0' : '-1'" [matTooltip]="input.value ? 'Clear' : ''" matTooltipShowDelay="500"></mat-icon>
  </div>
  <mat-autocomplete #auto="matAutocomplete">
    <!-- TODO: Alphabatise these -->
    @for (option of filteredOptions | async; track option; let i = $index) {
      <mat-option [value]="option">
        <span class="stay-open" (click)="stayOpen(option, $event)">
          <span>{{ option }}</span>
          <mat-icon fontIcon="close" class="remove-icon" tabindex="0"
            matTooltip="Removes the {{title}} from all existing prompts" matTooltipShowDelay="500"
            (click)="removeItem(option, $event)" (keydown.enter)="removeItem(option, $event)"
          (keydown.space)="removeItem(option, $event)"></mat-icon>
          <!-- FAVOURITE ICON CAN GO HERE -->
        </span>
      </mat-option>
    }
    @if ((suggestedOptions$ | async)?.length !== 0) {
      <span class="sub-heading">Suggested {{title | lowercase}}...</span>
    }
    @for (suggestedOption of suggestedOptions$ | async; track suggestedOption; let i = $index) {
      <mat-option [value]="suggestedOption.option" [disabled]="suggestedOption.added"
        [matTooltip]="suggestedOption.added ? '{{title}} added above' : ''" matTooltipShowDelay="500" matTooltipPosition="left" class="suggested-options">
        <span class="stay-open" (click)="addSuggestionToList(suggestedOption.option, $event, i)">
          <span>{{ suggestedOption.option }}</span>
          @if (suggestedOption.added) {
            <mat-icon fontIcon="check" class="tick-icon"></mat-icon>
          }
        </span>
      </mat-option>
    }
  </mat-autocomplete>
